module.exports = __webpack_public_path__ + "static/media/left.cd08fb06.svg";